export default __webpack_public_path__ + "static/media/store_360.452759c7.svg";